/* Plock-CI: Brutto/Netto-Preisumschalter fuers Stoebern & den Warenkorb.
   Wichtig: betrifft NUR die Anzeige auf den Shop-Seiten (Kategorie/Produkt/Warenkorb/Suche/
   Empfehlungen). Die eigentliche Shopify-Kasse zeigt immer den regulaeren Preis (inkl. MwSt.,
   so wie er auch ohne diesen Umschalter angezeigt wuerde) - das ist so mit der Ladenbesitzerin
   abgestimmt.

   Funktionsweise: durchsucht die sichtbaren Textknoten der Seite nach deutsch formatierten
   Geldbetraegen ("12,34 €" oder "€12,34"), umschliesst jeden Treffer einmalig mit einem
   <span class="plock-price-amount" data-gross="12.34" data-style="suffix">, und schaltet beim
   Umschalten NUR den Text dieser Spans um (nie den Rest der Seite).

   MwSt.-Satz: fest auf 19% (deutscher Regelsatz) gesetzt.

   Ankuendigungsleiste ("Kostenfreie Lieferung ab ... €") wird ueber eine eigene, separate Logik
   behandelt: der dort hinterlegte Betrag (200,00 €) ist als NETTO-Schwelle gemeint. Bei
   "exkl. MwSt." wird der Betrag unveraendert gezeigt (200,00 €), bei "inkl. MwSt." wird er auf
   den Brutto-Betrag hochgerechnet (200,00 € * 1,19 = 238,00 €).

   v2: einzelner An/Aus-Schalter statt zwei Buttons, mit Textlabel daneben.
   v3: Ankuendigungsleisten-Betrag schaltet jetzt ebenfalls mit um.
   v4: WICHTIGER BUGFIX - der MutationObserver reagierte bisher nur auf neu eingefuegte
   ELEMENT-Knoten (childList). Wenn Shopify einen Preis per direktem Text-Update neu rendert
   (z.B. beim Aendern der Menge, bei Warenkorb-AJAX-Updates, oder wenn ein Preis-Element per
   textContent statt per komplettem HTML-Austausch aktualisiert wird), entstehen dabei reine
   Text-Knoten-Mutationen (characterData) bzw. hinzugefuegte TEXT-Knoten statt Element-Knoten -
   das wurde bisher komplett ignoriert. Ergebnis: nach mehrfachem Umschalten/Interagieren zeigten
   einzelne Preise den falschen (nicht umgerechneten) Wert, obwohl der Schalter korrekt stand.
   Jetzt beobachtet der MutationObserver zusaetzlich characterData-Aenderungen und behandelt auch
   neu hinzugefuegte Text-Knoten; um dabei keine Endlosschleife durch die eigenen Text-Updates
   (applyMode/applyAnnouncementMode) auszuloesen, wird der Observer waehrend jedes eigenen
   Schreibvorgangs kurz pausiert (disconnect/reconnect).
   v5: MwSt.-Hinweistext auf der Produktseite ("zzgl./inkl. Mehrwertsteuer") reagiert jetzt
   ebenfalls auf den Umschalter. Der Text-Block im Theme-Editor laesst keine eigene CSS-Klasse
   auf dem <p> zu (wird vom Rich-Text-Sanitizer entfernt), daher wird das Element stattdessen
   anhand seines exakten Textinhalts ("zzgl. Mehrwertsteuer" / "inkl. Mehrwertsteuer") gefunden.
   v6: KRITISCHER BUGFIX - die im Shop hinterlegten Preise (product.price) sind NETTO-Preise
   (Shopify selbst rechnet an der Kasse automatisch 19% MwSt. dazu, taxesIncluded=false). Dieses
   Skript ging bisher faelschlicherweise davon aus, der angezeigte/hinterlegte Preis sei bereits
   BRUTTO, und liess ihn im Default-Modus ('brutto') unveraendert stehen - dadurch wurde ueberall
   im Shop der Netto-Preis gezeigt, aber faelschlich mit "inkl. Mehrwertsteuer" beschriftet (zu
   niedriger Preis, falsch ausgezeichnet). Jetzt gilt: der hinterlegte/angezeigte Preis ist NETTO;
   im Modus 'netto' wird er unveraendert gezeigt, im Modus 'brutto' (Standard) wird er mit *1,19
   auf den echten Bruttopreis hochgerechnet. Das Attribut heisst weiterhin "data-gross" (aus
   Kompatibilitaetsgruenden), enthaelt aber technisch den NETTO-Ausgangswert.
   v7: Barrierefreiheits-Feinschliff - der Umschalter sitzt jetzt optisch in einer weissen Pille
   (siehe snippets/header-actions.liquid), die auch den Label-Text umfasst.
   v8: Robuster Klick-Handler - frueher hatten der Switch UND der umgebende Wrapper je einen
   eigenen Klick-Listener (mit einer Ausnahme-Regel, damit nicht beide gleichzeitig feuern).
   Das hat in der Praxis dazu gefuehrt, dass ein Klick auf den Text zuverlaessig funktionierte,
   ein Klick direkt auf den kleinen Switch aber nicht. Jetzt gibt es dafuer nur noch EINEN
   einzigen Klick-Listener - direkt auf der Pille [data-price-toggle] - der bei jedem Klick
   irgendwo innerhalb der Pille (Switch, Knopf, Text, Polsterflaeche) ausloest. Da der Switch
   ein Kind-Element der Pille ist, erreicht ein Klick auf den Switch diesen Listener ganz normal
   per Event-Bubbling - es gibt keinen Sonderfall und keine Ausnahme mehr, die fehlschlagen
   koennte. */
(function () {
  var VAT_RATE = 0.19;
  var STORAGE_KEY = 'plock-price-mode';
  var MONEY_RE = /€\s?\d{1,3}(?:\.\d{3})*,\d{2}|\d{1,3}(?:\.\d{3})*,\d{2}\s?€/g;
  var SKIP_SELECTOR = 'script, style, noscript, .announcement-bar, .plock-price-toggle';
  var ANNOUNCEMENT_SELECTOR = '.announcement-bar__text';
  var VAT_HINT_TEXTS = ['zzgl. Mehrwertsteuer', 'inkl. Mehrwertsteuer'];
  var OBSERVER_OPTIONS = { childList: true, subtree: true, characterData: true };

  var observer = null;

  function parseAmount(raw) {
    var numMatch = raw.match(/\d{1,3}(?:\.\d{3})*,\d{2}/);
    if (!numMatch) return null;
    var normalized = numMatch[0].replace(/\./g, '').replace(',', '.');
    var value = parseFloat(normalized);
    return isNaN(value) ? null : value;
  }

  function formatAmount(value, style) {
    var rounded = Math.round(value * 100) / 100;
    var parts = rounded.toFixed(2).split('.');
    var intPart = parts[0];
    var decPart = parts[1];
    var negative = intPart.charAt(0) === '-';
    if (negative) intPart = intPart.slice(1);
    var withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var numStr = (negative ? '-' : '') + withThousands + ',' + decPart;
    return style === 'prefix' ? '€' + numStr : numStr + ' €';
  }

  function isInsideSkipped(el) {
    while (el) {
      if (el.nodeType === 1 && el.matches && el.matches(SKIP_SELECTOR)) return true;
      if (el.nodeType === 1 && el.classList && el.classList.contains('plock-price-amount')) return true;
      el = el.parentNode;
    }
    return false;
  }

  function wrapPrices(root) {
    if (!root || root.nodeType !== 1) return;
    if (isInsideSkipped(root)) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue) return NodeFilter.FILTER_REJECT;
        MONEY_RE.lastIndex = 0;
        if (!MONEY_RE.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        if (isInsideSkipped(node.parentNode)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var textNodes = [];
    var n;
    while ((n = walker.nextNode())) textNodes.push(n);

    textNodes.forEach(function (textNode) {
      var text = textNode.nodeValue;
      MONEY_RE.lastIndex = 0;
      var match;
      var lastIndex = 0;
      var frag = document.createDocumentFragment();
      var hasMatch = false;

      while ((match = MONEY_RE.exec(text))) {
        hasMatch = true;
        if (match.index > lastIndex) {
          frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        }
        var raw = match[0];
        var amount = parseAmount(raw);
        if (amount === null) {
          frag.appendChild(document.createTextNode(raw));
        } else {
          var style = raw.trim().charAt(0) === '€' ? 'prefix' : 'suffix';
          var span = document.createElement('span');
          span.className = 'plock-price-amount';
          span.setAttribute('data-gross', String(amount));
          span.setAttribute('data-style', style);
          span.textContent = raw;
          frag.appendChild(span);
        }
        lastIndex = match.index + raw.length;
      }

      if (hasMatch) {
        if (lastIndex < text.length) {
          frag.appendChild(document.createTextNode(text.slice(lastIndex)));
        }
        if (textNode.parentNode) {
          textNode.parentNode.replaceChild(frag, textNode);
        }
      }
    });
  }

  function applyMode(mode) {
    document.querySelectorAll('.plock-price-amount').forEach(function (span) {
      var netto = parseFloat(span.getAttribute('data-gross'));
      var style = span.getAttribute('data-style');
      if (isNaN(netto)) return;
      var value = mode === 'netto' ? netto : netto * (1 + VAT_RATE);
      var next = formatAmount(value, style);
      if (span.textContent !== next) span.textContent = next;
    });
  }

  function isInsideAnnouncementAmount(el) {
    while (el) {
      if (el.nodeType === 1 && el.classList && el.classList.contains('plock-announcement-amount')) return true;
      el = el.parentNode;
    }
    return false;
  }

  function wrapAnnouncementAmounts() {
    document.querySelectorAll(ANNOUNCEMENT_SELECTOR).forEach(function (root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          if (!node.nodeValue) return NodeFilter.FILTER_REJECT;
          MONEY_RE.lastIndex = 0;
          if (!MONEY_RE.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
          if (isInsideAnnouncementAmount(node.parentNode)) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      var textNodes = [];
      var n;
      while ((n = walker.nextNode())) textNodes.push(n);

      textNodes.forEach(function (textNode) {
        var text = textNode.nodeValue;
        MONEY_RE.lastIndex = 0;
        var match;
        var lastIndex = 0;
        var frag = document.createDocumentFragment();
        var hasMatch = false;

        while ((match = MONEY_RE.exec(text))) {
          hasMatch = true;
          if (match.index > lastIndex) {
            frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
          }
          var raw = match[0];
          var amount = parseAmount(raw);
          if (amount === null) {
            frag.appendChild(document.createTextNode(raw));
          } else {
            var style = raw.trim().charAt(0) === '€' ? 'prefix' : 'suffix';
            var span = document.createElement('span');
            span.className = 'plock-announcement-amount';
            span.setAttribute('data-netto', String(amount));
            span.setAttribute('data-style', style);
            span.textContent = raw;
            frag.appendChild(span);
          }
          lastIndex = match.index + raw.length;
        }

        if (hasMatch) {
          if (lastIndex < text.length) {
            frag.appendChild(document.createTextNode(text.slice(lastIndex)));
          }
          if (textNode.parentNode) {
            textNode.parentNode.replaceChild(frag, textNode);
          }
        }
      });
    });
  }

  function applyAnnouncementMode(mode) {
    document.querySelectorAll('.plock-announcement-amount').forEach(function (span) {
      var netto = parseFloat(span.getAttribute('data-netto'));
      var style = span.getAttribute('data-style');
      if (isNaN(netto)) return;
      var value = mode === 'brutto' ? netto * (1 + VAT_RATE) : netto;
      var next = formatAmount(value, style);
      if (span.textContent !== next) span.textContent = next;
    });
  }

  function applyVatHint(mode) {
    var isNetto = mode === 'netto';
    var target = isNetto ? 'zzgl. Mehrwertsteuer' : 'inkl. Mehrwertsteuer';
    document.querySelectorAll('p').forEach(function (p) {
      if (p.children.length > 0) return;
      var t = p.textContent.trim();
      if (VAT_HINT_TEXTS.indexOf(t) !== -1 && t !== target) {
        p.textContent = target;
      }
    });
  }

  function getSavedMode() {
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved === 'netto' || saved === 'brutto') return saved;
    } catch (e) {
      /* localStorage nicht verfuegbar - Standard verwenden */
    }
    return 'brutto';
  }

  function syncSwitch(mode) {
    var isNetto = mode === 'netto';
    document.querySelectorAll('[data-price-switch]').forEach(function (sw) {
      sw.setAttribute('aria-checked', isNetto ? 'true' : 'false');
    });
    document.querySelectorAll('[data-price-label]').forEach(function (label) {
      label.textContent = isNetto ? 'Preise exkl. MwSt.' : 'Preise inkl. MwSt.';
    });
    applyVatHint(mode);
  }

  function performToggle() {
    var next = getSavedMode() === 'netto' ? 'brutto' : 'netto';
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      /* ignore */
    }
    withObserverPaused(function () {
      applyMode(next);
      applyAnnouncementMode(next);
      syncSwitch(next);
    });
  }

  /* v8: EIN Klick-Listener pro Pille, direkt auf dem Wrapper [data-price-toggle]. Jeder Klick
     innerhalb der Pille (Switch, Knopf, Label-Text) erreicht diesen Listener per Bubbling -
     kein Sonderfall fuer den Switch mehr, daher kann "Text funktioniert, Switch nicht" nicht
     mehr auftreten. */
  function bindToggleButtons() {
    document.querySelectorAll('[data-price-toggle]').forEach(function (wrap) {
      if (wrap.dataset.plockBound) return;
      wrap.dataset.plockBound = 'true';
      wrap.addEventListener('click', function () {
        performToggle();
      });
    });
  }

  /* Pausiert den MutationObserver waehrend fn() laeuft, damit unsere eigenen DOM-Schreibvorgaenge
     (neue Spans einfuegen, Textinhalt von Spans aendern) nicht selbst wieder eine Beobachtung
     ausloesen und damit eine Endlosschleife erzeugen. */
  function withObserverPaused(fn) {
    if (observer) observer.disconnect();
    fn();
    if (observer) observer.observe(document.body, OBSERVER_OPTIONS);
  }

  function refreshAll() {
    wrapPrices(document.body);
    wrapAnnouncementAmounts();
    var mode = getSavedMode();
    applyMode(mode);
    applyAnnouncementMode(mode);
    bindToggleButtons();
    syncSwitch(mode);
  }

  function init() {
    refreshAll();

    observer = new MutationObserver(function () {
      withObserverPaused(refreshAll);
    });
    observer.observe(document.body, OBSERVER_OPTIONS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
